import CustomButton from "components/Atoms/CustomButton"
import useRouteStore from "pages/fsm/routes.store"
import React from "react"
const OutletDeSelectAll = () => {
  const { isInderminate: totalOutlets, deSelectAll } = useRouteStore(store => ({
    isInderminate: store.data.selectedOutlets.length,
    deSelectAll: store.deSelectAll,
  }))
  if (!totalOutlets) return null
  return (
    <CustomButton onClick={deSelectAll} small outlined minimal intent="danger">
      de-select ({totalOutlets}) outlets
    </CustomButton>
  )
}

export default OutletDeSelectAll
